import styled from "styled-components";
import { MenuItem, Chip } from "@mui/material";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 16px;
  overflow: auto;
  background: ${({ theme }) => theme.contentBackground};
`;

export const HeaderCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  color: #1f2937;
`;

export const FiltersCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 18px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const FiltersTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const FiltersTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  color: #111827;
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
`;

export const FieldWrapper = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const FieldInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  }
`;

export const TableCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const TableHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const TableTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  color: #111827;
`;

export const TableMeta = styled.div`
  color: #64748b;
  font-size: 12px;
`;

export const TableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
`;

export const Table = styled.table`
  width: 100%;
  min-width: 1400px;
  border-collapse: collapse;
  font-size: 12px;
`;

export const TableHead = styled.thead`
  background: #f8fafc;

  th {
    text-align: left;
    padding: 10px 12px;
    color: #334155;
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 1;
  }
`;

export const TableBody = styled.tbody`
  tr:nth-child(even) {
    background: #f8fafc;
  }

  tr:hover {
    background: #f1f5f9;
  }

  td {
    padding: 10px 12px;
    color: #0f172a;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: top;
    max-width: 320px;
    word-break: break-word;
  }
`;

export const TdNowrap = styled.td`
  white-space: nowrap;
`;

export const SedeTd = styled.td`
  white-space: nowrap;
  max-width: 240px;
  width: 240px;
  overflow: hidden;
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${({ tone = "default" }) =>
    tone === "danger"
      ? "#fee2e2"
      : tone === "warning"
      ? "#fef3c7"
      : tone === "info"
      ? "#dbeafe"
      : tone === "success"
      ? "#dcfce7"
      : "#e2e8f0"};
  color: ${({ tone = "default" }) =>
    tone === "danger"
      ? "#991b1b"
      : tone === "warning"
      ? "#92400e"
      : tone === "info"
      ? "#1e40af"
      : tone === "success"
      ? "#166534"
      : "#475569"};
  font-size: 11px;
  font-weight: 700;
  border: 1px solid
    ${({ tone = "default" }) =>
      tone === "danger"
        ? "#fecaca"
        : tone === "warning"
        ? "#fde68a"
        : tone === "info"
        ? "#bfdbfe"
        : tone === "success"
        ? "#bbf7d0"
        : "#cbd5e1"};
  white-space: nowrap;
`;

export const SedePill = styled(Pill)`
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 6px 2px 0;
`;

export const PaginationButtons = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
`;

export const PaginationButton = styled.button`
  border: 0;
  border-radius: 6px;
  padding: 6px 10px;
  min-width: 32px;
  background: ${({ active, disabled }) =>
    active ? "#2563eb" : disabled ? "#f8fafc" : "#ffffff"};
  color: ${({ active, disabled }) =>
    active ? "#ffffff" : disabled ? "#94a3b8" : "#334155"};
  font-size: 12px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const EmptyState = styled.div`
  padding: 48px 16px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
`;

export const ActionButtons = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const PlaceholderText = styled.span`
  color: #94a3b8;
`;

export const ChipsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const FiltroChip = styled(Chip).attrs(() => ({
  size: "small",
}))`
  &.MuiChip-root {
    height: 20px;
    font-size: 11px;
    background-color: #f1f5f9;
  }
`;

export const FiltroMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    font-size: 13px;
  }
`;

export const ThCheck = styled.th`
  width: 44px;
  text-align: center !important;
  padding: 8px 6px !important;
`;

export const TdCheck = styled.td`
  width: 44px;
  text-align: center;
  padding: 8px 6px !important;
`;

export const CheckboxInput = styled.input`
  cursor: pointer;
  width: 15px;
  height: 15px;
  accent-color: #2563eb;
  vertical-align: middle;
`;

export const ThActions = styled.th`
  text-align: center !important;
  width: 110px;
  min-width: 110px;
`;

export const TdActions = styled.td`
  text-align: center;
  white-space: nowrap;
  width: 110px;
  min-width: 110px;
`;

export const InactivarBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #dc2626;
  font-size: 11px;
  font-weight: 600;
  font-family: var(--font-body);
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover:not(:disabled) {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #b91c1c;
    box-shadow: 0 1px 3px rgba(220, 38, 38, 0.15);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    font-size: 11px;
  }
`;

